var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRejectedIcn({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "467.5 267.5 25 25",
    style: {
      enableBackground: "new 467.5 267.5 25 25"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ED5565;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M467.6,280c0-6.9,5.5-12.5,12.4-12.5s12.4,5.6,12.4,12.5s-5.5,12.5-12.4,12.5S467.6,286.9,467.6,280z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M473,280.6h0.8h0.3V280h-0.3c-0.5,0-0.9-0.4-0.9-0.8c0-0.5,0.4-0.8,0.9-0.8h0.7h0.2v-0.6h-0.2 c-0.4,0-0.8-0.4-0.8-0.8s0.4-0.8,0.8-0.8h0.8h0.1v-0.6h-0.1c-0.5,0-0.9-0.4-0.9-0.8s0.4-0.8,0.9-0.8h0.8h4.3c0.6,0,1.8,0.5,2.7,0.9 c0.9,0.4,1.4,0.6,1.8,0.6h2.9v6.2c-0.6,0-1.9,0-2.7,0c-1.2,0-1.9,0.5-3.5,1.9c-1.8,1.5-1.9,4.1-1.9,4.7c0,0.3-0.4,0.4-0.6,0.4 c-0.3,0-1.1,0-1.1-1.7c0-2.1,1.1-4.2,1.1-4.2l0.2-0.5h-2.1h-1.4h-0.5l0,0H473c-0.5,0-0.8-0.3-0.8-0.8 C472.1,281,472.5,280.6,473,280.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRejectedIcn);
export default __webpack_public_path__ + "static/media/rejected_icn.70f1d84f5e27f80d0ba35e7465242b63.svg";
export { ForwardRef as ReactComponent };